'use client';

import { ApolloLink, HttpLink, split } from '@apollo/client';
import React from 'react';
import {
  ApolloNextAppProvider,
  ApolloClient,
  InMemoryCache,
} from '@apollo/experimental-nextjs-app-support';
import { SSELink } from './sse.link';
import { getMainDefinition } from '@apollo/client/utilities';

const httpLink = new HttpLink({
  uri: process.env.NEXT_PUBLIC_GRAPHQL_SERVER_URL + '/api/graphql', // Your Yoga endpoint
});

// Add auth headers to the http link
const authLink = new ApolloLink((operation, forward) => {
  // Get the authentication token from local storage if it exists
  let token = '';
  if (typeof window !== 'undefined') {
    token = process.env.NEXT_PUBLIC_GRAPHQL_SERVER_TOKEN || '';
  }

  // Add the authorization header
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }));

  return forward(operation);
});

// Combine the auth link with the http link
const httpLinkWithAuth = authLink.concat(httpLink);

// Create an instance of SSELink for subscriptions
const sseLink = new SSELink({
  url: '/api/graphql', // Your Yoga endpoint for subscriptions
});

// Split logic for directing operations
const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  sseLink, // Use SSELink for subscriptions
  httpLinkWithAuth // Use HttpLink with auth for queries and mutations
);

function makeClient() {
  // use the `ApolloClient` from "@apollo/experimental-nextjs-app-support"
  return new ApolloClient({
    // use the `InMemoryCache` from "@apollo/experimental-nextjs-app-support"
    cache: new InMemoryCache(),
    link: link,
  });
}

// you need to create a component to wrap your app in
export function ApolloWrapper({ children }: React.PropsWithChildren) {
  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      {children}
    </ApolloNextAppProvider>
  );
}
